export class CapacityError extends Error {
  constructor() {
    super('One or more lanes have no capacity.')
    this.name = 'CapacityError'
  }
}
